import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { HttpClient } from '@angular/common/http';
import { SvcIssueAuditTrailContainerModel } from '../../../../../../models/aggregates/svc-issue-audit-trail'

@Injectable({
  providedIn: 'root'
})
export class SvcIssueAuditTrailService extends BaseApiTemplateService<SvcIssueAuditTrailContainerModel> {

  readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/issue-audit-trail/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/issue-audit-trail/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/issue-audit-trail/backoffice-ep';
    this.httpClient = http;
  }
}
